export default __webpack_public_path__ + "static/media/image.hashup.3f71336c.png";